import React from 'react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FeaturePlaceholder from '../FamilyCentral/FeaturePlaceholder';

const TodaysAgenda = () => {
    return (
        <FeaturePlaceholder 
            title="Today's Agenda"
            icon={CalendarTodayIcon}
            themeColor="#9f7aea"
        />
    );
};

export default TodaysAgenda;
